import type { Namespace, NamespaceFile, NamespaceFileUrl } from './types.js';

export const iam: Namespace = import.meta.glob<NamespaceFile>('../locales/*/iam.json' satisfies NamespaceFileUrl, {
    eager: true,
    import: 'default',
});
